import React, { useState } from 'react';
import './register.css';

const Register = () => {
  const [firstname, setFirstname] = useState('');
  const [surname, setSurname] = useState('');
  const [address, setAddress] = useState('');
  const [contact, setContact] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Basic Validation
    if (!firstname || !surname || !address || !contact || !email || !password || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch('https://schoolofservice.co.za/backend/register.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstname,
          surname,
          address,
          contact,
          email,
          password,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(data.message);
        // Clear the form
        setFirstname('');
        setSurname('');
        setAddress('');
        setContact('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
      } else {
        setError(data.message || 'Something went wrong');
      }
    } catch (err) {
      setError('Unable to connect to the server. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Register</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      <form onSubmit={handleSubmit}>
  <div className="mb-3 row">
    <label htmlFor="firstname" className="col-sm-2 col-form-label text-start">First Name</label>
    <div className="col-sm-10">
      <input
        type="text"
        className="form-control"
        id="firstname"
        placeholder="Enter your first name"
        value={firstname}
        onChange={(e) => setFirstname(e.target.value)}
      />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="surname" className="col-sm-2 col-form-label text-start">Surname</label>
    <div className="col-sm-10">
      <input
        type="text"
        className="form-control"
        id="surname"
        placeholder="Enter your surname"
        value={surname}
        onChange={(e) => setSurname(e.target.value)}
      />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="address" className="col-sm-2 col-form-label text-start">Address</label>
    <div className="col-sm-10">
      <input
        type="text"
        className="form-control"
        id="address"
        placeholder="Enter your address"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
      />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="contact" className="col-sm-2 col-form-label text-start">Phone Number</label>
    <div className="col-sm-10">
      <input
        type="text"
        className="form-control"
        id="contact"
        placeholder="Enter your phone number"
        value={contact}
        onChange={(e) => setContact(e.target.value)}
      />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="email" className="col-sm-2 col-form-label text-start">Email</label>
    <div className="col-sm-10">
      <input
        type="email"
        className="form-control"
        id="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="password" className="col-sm-2 col-form-label text-start">Password</label>
    <div className="col-sm-10">
      <input
        type="password"
        className="form-control"
        id="password"
        placeholder="Enter your password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="confirmPassword" className="col-sm-2 col-form-label text-start">Confirm Password</label>
    <div className="col-sm-10">
      <input
        type="password"
        className="form-control"
        id="confirmPassword"
        placeholder="Confirm your password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
    </div>
  </div>
  <button
    type="submit"
    className="btn btn-primary w-100"
    disabled={isLoading}
  >
    {isLoading ? 'Registering...' : 'Register'}
  </button>
</form>

    </div>
  );
};

export default Register;
